<template>
  <div class="addOrEditorTem">
    <div class="page_title">
      <div class="flex_between">
        <span>{{ routeQuery.is_add | titleText }}</span>
        <div>
          <el-button type="primary"
                     style="width: 92px"
                     size="medium"
                     @click="saveTemplate">保存</el-button>
          <el-button plain
                     style="width: 92px"
                     size="medium"
                     @click="back">返回</el-button>
        </div>
      </div>
      <div class="template-title">
        <p>{{ routeQuery.doctor_name }}</p>
        <p>{{ routeQuery.phone }}</p>
        <p>{{ routeQuery.hospital }}</p>
      </div>
    </div>

    <div class="container">
      <div class="template-content">
        <div class="template-name">
          <p>模板名称</p>
          <el-input placeholder="请输入内容"
                    v-model="inquiry_sheet_name"
                    maxlength="20"
                    show-word-limit
                    size="small"
                    clearable>
          </el-input>
          <el-checkbox v-model="is_default"
                       :true-label="1"
                       :false-label="0"
                       style="margin-left:20px">设置为指定问诊单</el-checkbox>
        </div>

        <div class="template-tmp_desc">
          <p>问诊单推送简介</p>
          <el-input placeholder="请输入内容"
                    type="textarea"
                    rows="3"
                    maxlength="300"
                    v-model="tmp_desc"
                    show-word-limit
                    size="small"
                    clearable>
          </el-input>
        </div>

        <div class="template-desc">
          <p>问诊单作用说明</p>
          <el-input placeholder="请输入内容"
                    type="textarea"
                    rows="4"
                    maxlength="500"
                    v-model="desc"
                    show-word-limit
                    size="small"
                    clearable>
          </el-input>
        </div>

        <div class="add-template">
          <el-link :underline="false"
                   @click="addTopic"><i class="el-icon-plus el-icon--right"></i> 添加题目</el-link>
        </div>

        <el-divider></el-divider>

        <div class="template-box">
          <div v-for="(item, index) in templateArr"
               :key="index">
            <!-- 单选 -->
            <template v-if="item.item_type == 1">
              <div class="template-content-box">
                <div class="template-item-box">
                  <div class="title">
                    <p>{{ index + 1 }}.</p>
                    <p>{{ item.title }}:</p>
                    <p class="interval"></p>
                    <p class="note">
                      (单选) {{ item.answer_obj | answerObjText }} ({{
                        item.is_write | isWriteText
                      }})
                    </p>
                  </div>
                  <el-radio-group v-model="radioVal">
                    <el-radio v-for="(radioItem, i) in item.content"
                              :key="i"
                              :label="radioItem"></el-radio>
                  </el-radio-group>
                </div>
                <!-- 操作 -->
                <div class="template-item-editor">
                  <el-button type="text"
                             @click="moveUp(index)">上移</el-button>
                  <el-button type="text"
                             @click="moveDown(index)">下移</el-button>
                  <el-button type="text"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('626')
                        : false
                    "
                             @click="editTopic(index, '1', item)">编辑</el-button>
                  <el-button type="text"
                             @click="delTopic(index)">删除</el-button>
                </div>
              </div>
              <el-divider v-if="index != templateArr.length - 1"
                          class="item-divider"></el-divider>
            </template>

            <!-- 多选 -->
            <template v-if="item.item_type == 2">
              <div class="template-content-box">
                <div class="template-item-box">
                  <div class="title">
                    <p>{{ index + 1 }}.</p>
                    <p>{{ item.title }}:</p>
                    <p class="interval"></p>
                    <p class="note">
                      (多选) {{ item.answer_obj | answerObjText }} ({{
                        item.is_write | isWriteText
                      }})
                    </p>
                  </div>

                  <div class="checkbox-item">
                    <el-checkbox v-for="(checkboxItem, i) in item.content"
                                 :key="i"
                                 :label="checkboxItem"></el-checkbox>
                  </div>
                </div>
                <!-- 操作 -->
                <div class="template-item-editor">
                  <el-button type="text"
                             @click="moveUp(index)">上移</el-button>
                  <el-button type="text"
                             @click="moveDown(index)">下移</el-button>
                  <el-button type="text"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('626')
                        : false
                    "
                             @click="editTopic(index, '2', item)">编辑</el-button>
                  <el-button type="text"
                             @click="delTopic(index)">删除</el-button>
                </div>
              </div>
              <el-divider v-if="index != templateArr.length - 1"
                          class="item-divider"></el-divider>
            </template>

            <!-- 问答 -->
            <template v-if="item.item_type == 3">
              <div class="template-content-box">
                <div class="template-item-box">
                  <div class="title">
                    <p>{{ index + 1 }}.</p>
                    <p>{{ item.title }}:</p>
                    <p class="interval"></p>
                    <p class="note">
                      (问答) {{ item.answer_obj | answerObjText }} ({{
                        item.is_write | isWriteText
                      }})
                    </p>
                  </div>

                  <div class="textarea-item">
                    <el-input type="textarea"
                              :placeholder="item.desc"
                              rows="4"
                              maxlength="300"
                              show-word-limit></el-input>
                  </div>
                </div>
                <!-- 操作 -->
                <div class="template-item-editor">
                  <el-button type="text"
                             @click="moveUp(index)">上移</el-button>
                  <el-button type="text"
                             @click="moveDown(index)">下移</el-button>
                  <el-button type="text"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('626')
                        : false
                    "
                             @click="editTopic(index, '3', item)">编辑</el-button>
                  <el-button type="text"
                             @click="delTopic(index)">删除</el-button>
                </div>
              </div>
              <el-divider v-if="index != templateArr.length - 1"
                          class="item-divider"></el-divider>
            </template>

            <!-- 填空 -->
            <template v-if="item.item_type == 4">
              <div class="template-content-box">
                <div class="template-item-box">
                  <div class="title">
                    <p>{{ index + 1 }}.</p>
                    <p>填空:</p>
                    <p class="interval"></p>
                    <p class="note">
                      {{ item.answer_obj | answerObjText }} ({{
                        item.is_write | isWriteText
                      }})
                    </p>
                  </div>

                  <div class="fillBOx-item">
                    <!-- <p class="desc">描述: </p> -->
                    <!-- <el-input type="textarea"
                              :placeholder="item.title"
                              rows="4"
                              maxlength="300"
                              show-word-limit></el-input> -->
                    <div v-html="getFillHtml(item.title)"
                         class="fill-box"></div>
                  </div>
                </div>
                <!-- 操作 -->
                <div class="template-item-editor">
                  <el-button type="text"
                             @click="moveUp(index)">上移</el-button>
                  <el-button type="text"
                             @click="moveDown(index)">下移</el-button>
                  <el-button type="text"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('626')
                        : false
                    "
                             @click="editTopic(index, '4', item)">编辑</el-button>
                  <el-button type="text"
                             @click="delTopic(index)">删除</el-button>
                </div>
              </div>
              <el-divider v-if="index != templateArr.length - 1"
                          class="item-divider"></el-divider>
            </template>

            <!-- 图片 -->
            <template v-if="item.item_type == 5">
              <div class="template-content-box">
                <div class="template-item-box">
                  <div class="title">
                    <p>{{ index + 1 }}.</p>
                    <p>{{ item.title }}:</p>
                    <p class="interval"></p>
                    <p class="note">
                      (图片) {{ item.answer_obj | answerObjText }} ({{
                        item.is_write | isWriteText
                      }})
                    </p>
                  </div>
                  <div class="img-box">
                    <i class="el-icon-plus"></i>
                  </div>
                  <div class="textarea-item"
                       v-if="item.is_desc">
                    <p class="desc">描述:</p>
                    <el-input type="textarea"
                              :placeholder="item.desc"
                              rows="4"
                              maxlength="300"
                              show-word-limit></el-input>
                  </div>
                </div>
                <!-- 操作 -->
                <div class="template-item-editor">
                  <el-button type="text"
                             @click="moveUp(index)">上移</el-button>
                  <el-button type="text"
                             @click="moveDown(index)">下移</el-button>
                  <el-button type="text"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('626')
                        : false
                    "
                             @click="editTopic(index, '5', item)">编辑</el-button>
                  <el-button type="text"
                             @click="delTopic(index)">删除</el-button>
                </div>
              </div>
              <el-divider v-if="index != templateArr.length - 1"
                          class="item-divider"></el-divider>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 题目类型 -->
    <el-dialog title="请选择题目类型"
               width="460px"
               style="text-align: left"
               :close-on-click-modal="false"
               :visible.sync="dialogTopic">
      <div class="add-radio">
        <!-- 1单选，2多选，3问答，4填空题，5图片 -->
        <el-radio-group v-model="addType">
          <el-radio :label="'1'">单选</el-radio>
          <el-radio :label="'2'">多选</el-radio>
          <el-radio :label="'3'">问答</el-radio>
          <el-radio :label="'4'">填空</el-radio>
          <el-radio :label="'5'">图片</el-radio>
        </el-radio-group>
      </div>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogTopic = false"
                   size="small">取 消</el-button>
        <el-button type="primary"
                   @click="comfirmTopic"
                   size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 单选 -->
    <add-radio v-if="addRadioDia"
               :isAdd="isAdd"
               :content="radioProp"
               @closeShow="closeShow"></add-radio>
    <!-- 多选 -->
    <add-checkbox v-if="addCheckboxDia"
                  :isAdd="isAdd"
                  :content="checkboxProp"
                  @closeShow="closeShow"></add-checkbox>

    <!-- 问答 -->
    <add-answers v-if="addAnswersDia"
                 :isAdd="isAdd"
                 :content="answersProp"
                 @closeShow="closeShow"></add-answers>
    <!-- 填空 -->
    <add-fill v-if="addFillDia"
              :isAdd="isAdd"
              :content="fillProp"
              @closeShow="closeShow"></add-fill>
    <!-- 图片 -->
    <add-img v-if="addImgDia"
             :isAdd="isAdd"
             :content="imgProp"
             @closeShow="closeShow"></add-img>
  </div>
</template>

<script>
import inquiryTemplate from '../../../../api/inquiryTemplate';
import AddRadio from '../components/AddRadio.vue';
import AddCheckbox from '../components/AddCheckbox.vue';
import AddAnswers from '../components/AddAnswers.vue';
import AddFill from '../components/AddFill.vue';
import AddImg from '../components/AddImg.vue';
export default {
  components: {
    AddRadio,
    AddCheckbox,
    AddAnswers,
    AddFill,
    AddImg
  },
  data() {
    return {
      radioVal: '',
      isAdd: 0,
      addType: '',
      dialogTopic: false,
      addRadioDia: false,
      radioProp: {},
      addCheckboxDia: false,
      checkboxProp: {},
      addAnswersDia: false,
      answersProp: {},
      addFillDia: false,
      fillProp: {},
      addImgDia: false,
      imgProp: {},
      inquiry_sheet_name: '',
      is_default: 0,
      tmp_desc: '',
      desc: '',
      templateArr: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    routeQuery() {
      return this.$route.query;
    }
  },
  filters: {
    titleText(val) {
      switch (val) {
        case '-1':
          return '新增问诊单模板';
        default:
          return '编辑问诊单模板';
      }
    },
    answerObjText(val) {
      switch (val) {
        case 1:
          return '患者回答';
        case 2:
          return '医生回答';
        case 3:
          return '医生患者都可回答';
      }
    },
    isWriteText(val) {
      switch (val) {
        case 1:
          return '必填';
        case 0:
          return '非必填';
      }
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getFillHtml(str) {
      return str.replace(/\{\$(.+?)\}/g, (match) => {
        let newMatch = match.replace(/\{/g, '');
        newMatch = newMatch.replace(/\}/g, '');
        newMatch = newMatch.replace(/\$/g, '');
        let html = `<div class="item-fill">${newMatch}</div>`;
        return html;
      });
    },
    // 获取详情
    getInfo() {
      if (this.routeQuery.is_add != '-1') {
        this.inquiry_sheet_name = this.routeQuery.inquiry_sheet_name;
        inquiryTemplate
          .getInquirySheetInfo({
            inquiry_sheet_id: this.routeQuery.inquiry_sheet_id
          })
          .then((res) => {
            let { data } = res;
            data.item = data.item.map((item) => {
              if (item.item_type == 1 || item.item_type == 2) {
                item.content = item.content.split('^');
              }
              return item;
            });

            this.desc = data.desc;
            this.tmp_desc = data.tmp_desc;
            this.templateArr = data.item;
            this.is_default = data.is_default;
          });
      }
    },
    addTopic() {
      this.addType = '';
      this.dialogTopic = true;
    },
    comfirmTopic() {
      if (this.addType == '') {
        this.$message.error('请选择题目类型');
        return;
      }
      this.isAdd = 0;
      this.dialogTopic = false;
      switch (this.addType) {
        case '1':
          this.addRadioDia = true;
          break;
        case '2':
          this.addCheckboxDia = true;
          break;
        case '3':
          this.addAnswersDia = true;
          break;
        case '4':
          this.addFillDia = true;
          break;
        case '5':
          this.addImgDia = true;
          break;
      }
    },
    closeShow(data) {
      switch (this.addType) {
        case '1':
          this.addRadioDia = false;
          break;
        case '2':
          this.addCheckboxDia = false;
          break;
        case '3':
          this.addAnswersDia = false;
          break;
        case '4':
          this.addFillDia = false;
          break;
        case '5':
          this.addImgDia = false;
          break;
      }
      if (data) {
        // console.log(data);
        if (data.item_type == 1 || data.item_type == 2) {
          data.content = data.content.map((item) => {
            return item.value;
          });
        }
        !this.isAdd
          ? this.templateArr.push(data)
          : this.templateArr.splice(data.$index, 1, data);
      }
      // console.log('数据', this.templateArr);
    },
    // 保存模板
    saveTemplate() {
      if (!this.templateArr.length) {
        this.$message.warning('请添加题目');
        return;
      }
      if (this.inquiry_sheet_name == '') {
        this.$message.warning('请填写模板名称');
        return;
      }
      this.templateArr.map((item) => {
        if (item.item_type == 1 || item.item_type == 2) {
          item.content = item.content.join('^');
        }
        return item;
      });
      let params = {
        inquiry_sheet_name: this.inquiry_sheet_name,
        desc: this.desc,
        tmp_desc: this.tmp_desc,
        item: this.templateArr,
        is_default: this.is_default
      };
      // console.log(params);
      if (this.routeQuery.is_add == '-1') {
        params['doctor_id'] = this.routeQuery.doctor_id;
        inquiryTemplate.createInquirySheet(params).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success('保存模板成功');
            this.back();
          }
        });
      } else {
        params['inquiry_sheet_id'] = this.routeQuery.inquiry_sheet_id;
        inquiryTemplate.updateInquirySheet(params).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success('修改模板成功');
            this.back();
          }
        });
      }
    },
    // 交换元素
    swapItems(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    // 上移
    moveUp(index) {
      if (!index) {
        this.$message.warning('已经是第一个啦');
        return;
      }
      this.swapItems(this.templateArr, index, index - 1);
    },
    // 下移
    moveDown(index) {
      if (index == this.templateArr.length - 1) {
        this.$message.warning('已经在最后啦');
        return;
      }
      this.swapItems(this.templateArr, index, index + 1);
    },
    // 编辑
    editTopic(index, type, row) {
      let copyRow = JSON.parse(JSON.stringify(row));
      copyRow['$index'] = index;
      if (copyRow.content) {
        copyRow.content = copyRow.content.map((item, index) => {
          item = {
            id: index,
            value: item
          };
          return item;
        });
      }
      // console.log(copyRow);
      this.addType = type;
      this.isAdd = 1;
      switch (type) {
        case '1':
          this.addRadioDia = true;
          this.radioProp = copyRow;
          break;
        case '2':
          this.addCheckboxDia = true;
          this.checkboxProp = copyRow;
          break;
        case '3':
          this.addAnswersDia = true;
          this.answersProp = copyRow;
          break;
        case '4':
          this.addFillDia = true;
          this.fillProp = copyRow;
          break;
        case '5':
          this.addImgDia = true;
          this.imgProp = copyRow;
          break;
      }
    },
    // 删除
    delTopic(index) {
      this.templateArr.splice(index, 1);
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.addOrEditorTem {
  height: 100%;

  .add-radio {
    padding: 20px 20px 0 20px;
    font-size: 20px;
    ::v-deep .el-radio__label {
      font-size: 16px;
    }
  }
  .container {
    padding: 20px;
    border-radius: 5px;
  }
  .page_title {
    height: 82px;
  }
  .el-divider--horizontal {
    margin: 20px 0 0 0;
  }
  .item-divider {
    width: 50%;
    margin: 12px 0 0 0;
  }

  .template-title {
    // width: 600px;
    height: 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
    p {
      line-height: 20px;
      margin-right: 20px;
      display: flex;
      align-items: center;
    }
  }
  .template-content {
    padding: 0 10px 10px 10px;
    background-color: #fbfbfb;
    min-height: calc(100vh - 185px);
    .template-name {
      width: 620px;
      display: flex;
      align-items: center;
      p {
        width: 234px;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
      }
    }
    .template-tmp_desc {
      width: 620px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      p {
        width: 160px;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
      }
    }
    .template-desc {
      width: 620px;
      display: flex;
      align-items: center;
      p {
        width: 160px;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
      }
    }
    .add-template {
      display: flex;
      .el-link {
        font-size: 16px;
        color: #40aaff;
      }
    }
    .template-box {
      .template-content-box {
        display: flex;
        align-items: center;
        .template-item-box {
          width: 50%;
          .title {
            display: flex;
            align-items: center;
            font-size: 16px;
            .interval {
              width: 100px;
            }
            .note {
              color: #cac7c7;
              font-size: 14px;
            }
          }
          .el-radio-group {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            line-height: 30px;
            padding-left: 20px;
            .el-radio {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              ::v-deep .el-radio__label {
                font-size: 16px;
                white-space: normal;
              }
            }
          }
          .checkbox-item {
            display: flex;
            flex-wrap: wrap;
            line-height: 30px;
            padding-left: 20px;
            .el-checkbox {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              ::v-deep .el-checkbox__label {
                white-space: normal;
              }
            }
          }
          .textarea-item {
            width: 50%;
            .desc {
              text-align: left;
              color: #cac7c7;
              font-size: 15px;
              margin: 0 0 4px 0;
            }
          }
          .fillBOx-item {
            .fill-box {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              line-height: 30px;
              ::v-deep .item-fill {
                white-space: nowrap;
                height: 20px;
                padding: 0 6px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #000;
              }
            }
          }
          .img-box {
            width: 100px;
            height: 100px;
            border-radius: 6px;
            border: 1px dashed #c0ccda;
            margin-bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
              font-size: 20px;
            }
          }
        }
        .template-item-editor {
          // width: 50%;
          button {
            width: 60px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>